/* eslint-disable */
import React from "react";
import { Navigate } from "react-router-dom";
import { all_routes } from "./all_routes";
import useStore from "../store/store";

const PublicRoute = ({ children }) => {
  const user = useStore((state) => state.user);

  // If user is already logged in, redirect to dashboard
  if (user?.token) {
    return <Navigate to={all_routes.newdashboard} replace />;
  }

  return children;
};

export default PublicRoute;
